import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";
import { eduCommonMessages } from "./common";
import { eduDashboardPageMessages } from "./pages-dashboard";
import { eduCoursesPageMessages } from "./pages-courses";
import { eduProjectsPageMessages } from "./pages-projects";
import { eduPublicCoursesPageMessages } from "./pages-public-courses";
import { eduMembersAuthOrgsPageMessages } from "./pages-members-auth-orgs";
import { eduTeachingPlansPageMessages } from "./pages-teaching-plans";

const EDU_LOCALES = ["zh-CN", "en", "ja"] as const satisfies readonly AppLocale[];

const eduCatalogSlices: Array<Record<AppLocale, MessageTree>> = [
  eduCommonMessages,
  eduDashboardPageMessages,
  eduCoursesPageMessages,
  eduProjectsPageMessages,
  eduPublicCoursesPageMessages,
  eduMembersAuthOrgsPageMessages,
  eduTeachingPlansPageMessages,
];

function cloneMessageValue(value: string | MessageTree): string | MessageTree {
  if (typeof value === "string") {
    return value;
  }
  return mergeMessageTree({}, value);
}

function mergeMessageTree(target: MessageTree, source: MessageTree): MessageTree {
  Object.entries(source).forEach(([key, value]) => {
    const existing = target[key];
    if (value && typeof value === "object" && existing && typeof existing === "object") {
      target[key] = mergeMessageTree(existing, value);
      return;
    }
    target[key] = cloneMessageValue(value);
  });
  return target;
}

export const eduAdminMessages = Object.fromEntries(
  EDU_LOCALES.map((locale) => [
    locale,
    eduCatalogSlices.reduce<MessageTree>(
      (messages, slice) => mergeMessageTree(messages, slice[locale]),
      {},
    ),
  ]),
) as Record<AppLocale, MessageTree>;
